import React, {useEffect, useState} from "react";
import {Layout, Menu} from "antd";
import "./dashboard-sidebar.scss";
import {Logo} from "../../../../assets/icons/logo";
import {useLocation, useNavigate} from "react-router";
import {useUser} from "../../../providers/UserContext";
import {GoChevronLeft} from "react-icons/go";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {
    CoachingIocnSvg,
    CoursesIcon,
    ForumIcon,
    GoalIcon,
    homeIcon,
    journalIcon,
    settingIcon,
    VaultIcon
} from "../../../../assets/icons/sidebarIcons";
import {Link} from "react-router-dom";

const { Header, Sider, Content } = Layout;

const DashboardSidebar = React.forwardRef(
    ({ ref5, collapsed, setCollapsed }, ref) => {
        const { user, sidebarSwitcher, sidebarCollapse, setSidebarCollapse } =
            useUser();
        const [theme, setTheme] = useState(localStorage.getItem("theme"));
        const location = useLocation();
        const [currentRoute, setCurrentRoute] = useState("");
        const [isMobileView, setIsMobileView] = useState(false);
        const navigate = useNavigate();
        const [profileDatas, setProfileDatas] = useState(false);

        async function GetProfileData() {
            const response = await UserAuthService.getProfileData();
            if (response?.data?.data?.status) {
                setProfileDatas(response.data?.data?.data?.user);
            }
        }

        useEffect(() => {
            GetProfileData();
        }, []);

        const SidebarContent = [
            {
                key: "/",
                route: "/",
                icon: <span className={"ant-menu-item-icon"}>{homeIcon}</span>,
                label: <Link to={"/"}>Home</Link>,
                allow: ["artist", "fan", "venue"],
                show: true,
                // children: <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
                //     Ant Design
                // </a>,
                component: <div>ddddd</div>,
            },
            {
                key: "/vault",
                route: "/vault",
                icon: <span className={"ant-menu-item-icon"}>{VaultIcon}</span>,
                label: <Link to={"/vault"}>Vault</Link>,
                allow: ["artist", "fan", "venue"],
                show: true,
                // children: <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
                //     Ant Design
                // </a>,
                component: <div>ddddd</div>,
            },
            {
                key: "/courses",
                route: "/courses",
                icon: <span><CoursesIcon/></span>,
                label: <Link to={"/courses"}>Courses</Link>,
                show: true,
                allow: ["artist", "fan", "venue"],
                component: "",
            },
            {
                key: "/quests",
                route: "/quests",
                icon: <span>  <GoalIcon/></span>,
                label: <Link to={"/quests"}>Quest</Link>,
                allow: ["artist", "fan", "venue"],
                show: true,
                component: "",
            },
            {
                key: "/journals",
                route: "/journals",
                icon: <span>{journalIcon}</span>,
                label: <Link to={"/journals"}>Journals</Link>,
                allow: ["artist", "fan", "venue"],
                show: true,
                component: "",
            },

            {
                key: "/forum",
                route: "/forum",
                icon: <span><ForumIcon/></span>,
                label: <Link to={"/forum"}>Forum</Link>,
                allow: ["artist", "fan", "venue"],
                show: profileDatas.forumId ? true : false,
                component: "",
            },
            {
                key: "/coaching",
                route: "/coaching",
                icon: (
                        <span>
                            <CoachingIocnSvg />
                        </span>
                ),
                label: <Link to={"/coaching"}>Coaching</Link>,
                allow: ["artist", "fan", "venue"],
                show: profileDatas.isCoach ? true : false,
                component: "",
            },
            {
                key: "/settings",
                route: "/settings/",
                icon: <span>{settingIcon}</span>,
                label: <Link to={"/settings/change-password"}>Settings</Link>,
                allow: ["artist", "fan", "venue"],
                show: true,
                component: "",
            },
        ];

        const handleFilterAllowedModules = () => {
            return SidebarContent;
        };

        const menuItem = SidebarContent.filter((sidebarItem) =>
            sidebarItem.allow.includes(user.role)
        );

        useEffect(() => {
            setCurrentRoute(location.pathname);
        }, [location]);

        const isRouteActive = (route) => {
            // Check if the route is not the root path and the current route starts with the specified route
            return route !== "/" && location.pathname.startsWith(route);
        };

        function breakpoint(media) {
            setIsMobileView(media);
            if (media) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        }
        const handleClickMenu = () => {
            if (window.innerWidth < 850) {
                setSidebarCollapse(!sidebarCollapse);
            }
        };

        return (
            <div className={"dashboard-sidebar"}>
                <Sider
                    trigger={null}
                    className={`dashboard-sidebar ${isMobileView && "fixed-sidebar"}`}
                    collapsible
                    collapsed={collapsed}
                    width={258}
                    collapsedWidth={isMobileView ? 0 : 100}
                    onCollapse={(value) => setSidebarCollapse(value)}
                    breakpoint={"xl"}
                    onBreakpoint={(broken) => breakpoint(broken)}
                >
                    <div className={`sidebar-logo`}>
                        {!collapsed ? (
                            <div
                                className={"logo-full cp"}
                                onClick={() => {
                                    navigate("/");
                                }}
                            >
                                <Logo />
                            </div>
                        ) : (
                            <div
                                className={"logo-full cp"}
                                onClick={() => {
                                    navigate("/");
                                }}
                            >
                                {/*<LogoLarge/>*/}
                                <Logo />
                            </div>
                        )}
                        {isMobileView && (
                            <div
                                className={"side-close"}
                                onClick={() => {
                                    setCollapsed(!collapsed);
                                }}
                            >
                                <GoChevronLeft />
                            </div>
                        )}
                    </div>
                    <div ref={ref5}>
                        {/*<Menu*/}
                        {/*    theme="dark"*/}
                        {/*    mode="inline"*/}
                        {/*    selectedKeys={currentRoute}*/}
                        {/*    items={handleFilterAllowedModules()}*/}
                        {/*>*/}
                        {/*</Menu>*/}
                        <Menu theme="dark" mode="inline" selectedKeys={[currentRoute]}>
                            {handleFilterAllowedModules().map((sidebarItem) => {
                                return (
                                    <>
                                        {sidebarItem?.show == true ? (
                                            <Menu.Item
                                                onClick={handleClickMenu}
                                                key={sidebarItem.route}
                                                icon={sidebarItem.icon}
                                                className={
                                                    isRouteActive(sidebarItem.route)
                                                        ? "ant-menu-item-selected"
                                                        : ""
                                                }
                                            >
                                                {sidebarItem.label}
                                            </Menu.Item>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                );
                            })}
                        </Menu>
                    </div>

                    <div
                        className={`box-shadow-div ${
                            collapsed ? "collapsed" : "not-collapsed"
                        }`}
                    ></div>
                </Sider>
            </div>
        );
    }
);

export default DashboardSidebar;
